import { render, staticRenderFns } from "./RunnitTagTypeTabs.vue?vue&type=template&id=fc6f2f86"
import script from "./RunnitTagTypeTabs.vue?vue&type=script&lang=ts"
export * from "./RunnitTagTypeTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports